import { forwardRef } from "react";
import classnames from "classnames";
import styles from "@/styles/Form.module.scss";
import ErrorMessage from "./ErrorMessage";

const SingleCheckboxField = forwardRef((props, ref) => {
  const {
    error,
    title,
    name,
    label,
    disabled,
    defaultChecked,
    required,
    vwScale,
    ..._props
  } = props;
  return (
    <div className={styles.inputField}>
      {title && (
        <legend
          className={classnames(styles.formTitle, {
            [styles.required]: required,
            [styles.vwScale]: vwScale,
          })}
        >
          {title}
        </legend>
      )}
      <div
        className={classnames(styles.checkbox, {
          [styles.disabled]: disabled,
          [styles.vwScale]: vwScale,
        })}
      >
        <input
          ref={ref}
          id={`checkbox-${name}`}
          name={name}
          type="checkbox"
          defaultChecked={defaultChecked}
          disabled={disabled}
          {..._props}
        />
        <label
          htmlFor={`checkbox-${name}`}
          className={`${styles.label} ${disabled ? styles.disabled : ""}`}
          tabIndex="0"
        >
          <span>{label}</span>
        </label>
      </div>
      {error && <ErrorMessage msg={error} />}
    </div>
  );
});
SingleCheckboxField.displayName = "SingleCheckboxField";
export default SingleCheckboxField;
